/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { ITicketAttachmentList } from './Attachment';
import { ICustomFieldTicketList } from './CustomFieldTicketValue';
import { TicketFields } from '@touchplan/common';
import { logger } from '@touchplan/logging';

export class ClipboardData {
	private _tickets: TicketFields[]; // Never a falsy value
	private _planId: string;
	private _projectId: string;
	private _customFieldTicketValues: ICustomFieldTicketList;
	private _ticketAttachments: ITicketAttachmentList;

	constructor(
		tickets: TicketFields[] = new Array<TicketFields>(),
		planId: string = null,
		projectId: string = null,
		customFieldTicketValues: ICustomFieldTicketList = {},
		ticketAttachment: ITicketAttachmentList = {}
	) {
		this._tickets = tickets;
		this._planId = planId;
		this._projectId = projectId;
		this._customFieldTicketValues = customFieldTicketValues;
		this._ticketAttachments = ticketAttachment;
		// Verify that all tickets are either active side or pull side
		// (since "ticketsAreActiveSide()" returns a result based only on the first ticket)
		if (this.ticketCount() > 0) {
			let activeCount = 0;
			let plannedCount = 0;
			for (const t of this.tickets) {
				if (!!t.isActive) {
					activeCount += 1;
				} else {
					plannedCount += 1;
				}
			}
			if (activeCount > 0 && plannedCount > 0) {
				logger.log('The tickets have a mix of active and pull tickets');
				return;
			}
		}
	}

	get planId() {
		return this.ticketCount() > 0 ? this._planId : null;
	}

	get projectId() {
		return this.ticketCount() > 0 ? this._projectId : null;
	}

	get tickets() {
		return this._tickets;
	}

	get customFieldTicketValues() {
		return this._customFieldTicketValues;
	}

	get ticketAttachments() {
		return this._ticketAttachments;
	}

	public ticketCount() {
		return this.tickets.length;
	}

	public ticketCountString() {
		const numTickets = this.ticketCount();
		return numTickets > 0 ? numTickets.toString() : '';
	}

	public ticketsAreActiveSide(): boolean {
		return this.ticketCount() === 0 ? true : !!this.tickets[0].isActive;
	}
}
